<script lang="ts" context="module">
    import { writable } from "svelte/store"

    const selectedLesson = writable<number | null>(null)
    // const fakeLoaderDone = writable(false)
    // let fakeLoaderTimer : ReturnType<typeof setTimeout>

    /**
     * Opens the notification module to selected lesson
     * @param lesson
     */
    export function openNotificationManager(lesson: number) {
        // TODO: check notification permission here
        selectedLesson.set(lesson)
    }

    export function closeNotificationManager() {
        // clearTimeout(fakeLoaderTimer)
        selectedLesson.set(null)
    }
</script>

<script lang="ts">
    import PopupExit from "@components/popup/PopupExit.svelte"
    import PopupHeading from "@components/popup/PopupHeading.svelte"
    import PopupNoPortal from "@components/popup/PopupNoPortal.svelte"
    import NotificationManagerContent from "./NotificationManagerContent.svelte"
    import PermissionManager from "./PermissionManager.svelte"
    import Icon from "@components/material/Icon.svelte"
    import HelpIcon from "@components/help/HelpIcon.svelte"
    import {
        NotificationPermissions,
        notificationPermissions,
    } from "@utils/cap-notification-manager/notification-permission"
    import {
        Channel,
        currentNativeNotifications,
    } from "@utils/cap-notification-manager/cap-notification-manager"
    import { reminderMemoryManagerSettings } from "@utils/practice/reminder-memory-manager"
    import {
        LiveNotificationData,
        type NotificationDataType,
    } from "@utils/practice/notifications-data"
    import PopupCornerIcon from "@components/popup/PopupCornerIcon.svelte"
    import { goto } from "$app/navigation"
    import TooEarlyPopup from "./TooEarlyPopup.svelte"

    export let notfData: NotificationDataType
    export let liveData: LiveNotificationData

    $: memoryManager = $reminderMemoryManagerSettings

    $: notificationsSet =
        $currentNativeNotifications?.lesson === $selectedLesson && $selectedLesson !== null

    function gotoReminders() {
        goto("/account/settings#reminders")
    }
</script>

{#if $selectedLesson !== null}
    <PopupNoPortal
        class="absolute z-5"
        on:escape={closeNotificationManager}
        on:clickoutside={closeNotificationManager}
    >
        <PopupExit float on:exit={closeNotificationManager} />
        {#if $notificationPermissions !== null && memoryManager !== null}
            {#if $notificationPermissions === NotificationPermissions.GRANTED}
                {#if !notificationsSet && liveData.isTooEarly}
                    <TooEarlyPopup {gotoReminders} exit={closeNotificationManager} />
                {:else}
                    <PopupCornerIcon
                        icon="pen"
                        enabled={!notificationsSet}
                        label="Edit practice window"
                        float
                        class="right-12"
                        on:click={() => gotoReminders()}
                    />
                    <PopupHeading class="mb-2">
                        <span class="text-sm opacity-60">
                            Lesson {$selectedLesson} —
                            {#if notificationsSet && $currentNativeNotifications}
                                <b
                                    >{$currentNativeNotifications.notifications.filter(
                                        (notf) => notf.channel !== Channel.LESSON_REMINDER,
                                    ).length}</b
                                > reminder set today
                            {:else}
                                no reminders set
                            {/if}
                        </span> <br />
                        Practice reminders <HelpIcon
                            path="workbook-reminders#notification-management"
                        />
                    </PopupHeading>
                    <NotificationManagerContent
                        {notfData}
                        {liveData}
                        {memoryManager}
                        {notificationsSet}
                        lesson={$selectedLesson}
                        on:exit={closeNotificationManager}
                    />
                {/if}
            {:else}
                <PermissionManager
                    permissions={$notificationPermissions}
                    on:exit={closeNotificationManager}
                />
            {/if}
        {:else}
            <div class="w-full flex justify-center items-center gap-2">
                <Icon icon="loading" class="w-6" />
                Reminder settings are still loading. <br />
                Notification settings: {JSON.stringify($notificationPermissions)} <br />
                memory manager: {JSON.stringify(memoryManager)}
            </div>
        {/if}
    </PopupNoPortal>
{/if}
